/* eslint-disable react/display-name */
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const Wrapper = (props) => {
  const { as: Cmp = 'div', ...rest } = props;
  return <Cmp {...rest}>{props.children}</Cmp>;
};

Wrapper.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node,
};

const Text = ({ as = 'div', children, className, css, id, intl }) => {
  const newIntl = intl || id;
  const transformedValues = {
    strong: (chunks) => <strong>{chunks}</strong>,
    q: (chunks) => <q>{chunks}</q>,
    p: (chunks) => <address>{chunks}</address>,
    author: (chunks) => <address>{chunks}</address>,
  };

  return (
    <Wrapper as={as} css={css} className={className}>
      {newIntl ? <FormattedMessage id={newIntl} defaultMessage={children} values={transformedValues} /> : children}
    </Wrapper>
  );
};

Text.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
  css: PropTypes.object,
  id: PropTypes.string,
  intl: PropTypes.string,
  children: PropTypes.node,
};

export default Text;
